import { memo, ReactNode, useMemo } from 'react'
import {
  argent,
  braavos,
  publicProvider,
  StarknetConfig,
  useInjectedConnectors,
} from '@starknet-react/core'
import { goerli, mainnet } from '@starknet-react/chains'
import { Web3StarknetProviderUpdater } from './Updater'
import { isMainnet } from '../../config'

export const Web3StarknetProvider = memo<{
  children: ReactNode
}>(({ children }) => {
  const chains = useMemo(() => {
    return [isMainnet ? mainnet : goerli]
  }, [])
  const provider = publicProvider()
  const { connectors } = useInjectedConnectors({
    // Show these connectors if the user has no connector installed.
    recommended: [argent(), braavos()],
    // Hide recommended connectors if the user has any connector installed.
    includeRecommended: 'onlyIfNoConnectors',
    // Randomize the order of the connectors.
    order: 'alphabetical',
  })

  const enabledConnectors = useMemo(() => {
    return connectors.filter((connector) =>
      [argent().id].includes(connector.id),
    )
  }, [connectors])

  return (
    <StarknetConfig
      chains={chains}
      provider={provider}
      connectors={enabledConnectors}
    >
      {children}
      <Web3StarknetProviderUpdater />
    </StarknetConfig>
  )
})
